var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup408(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    transform: "translate(-46 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_644",
    fill: "none",
    d: "M0 0H50V50H0z",
    transform: "translate(46 248)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(52.897 253.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    d: "M54.114 281.765a8.624 8.624 0 0 1-6.981 3.562h-4.021a3.213 3.213 0 0 1-3.02-2.116 10.209 10.209 0 0 1-1.624-.642 10.942 10.942 0 0 1-3.034-2.246 12.954 12.954 0 0 0-10.16 12.647v.81a2.015 2.015 0 0 0 2.015 2.015h31.264a2.015 2.015 0 0 0 2.015-2.015v-.81a12.944 12.944 0 0 0-6.454-11.205z",
    className: "cls-2",
    transform: "translate(-25.274 -256.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M93.9 20.03a2.294 2.294 0 0 0 2.01-1.188l.031.084.009.025a8.955 8.955 0 0 0 5.05 5.316 3.209 3.209 0 0 1 2.72-1.5h4.022a2.251 2.251 0 0 0 1.1-.3 4.545 4.545 0 0 0 1.3-1.5 11.6 11.6 0 0 0 1.006-2.126 2.306 2.306 0 0 0 .634.731v.986a4.046 4.046 0 0 1-4.041 4.041h-4.022a1.377 1.377 0 1 0 0 2.753h4.022a6.8 6.8 0 0 0 6.795-6.795v-.986a2.291 2.291 0 0 0 .918-1.836v-5.743a2.291 2.291 0 0 0-.953-1.861 11.007 11.007 0 0 0-21.944 0 2.291 2.291 0 0 0-.953 1.861v5.743A2.3 2.3 0 0 0 93.9 20.03zm9.63-17.276a8.265 8.265 0 0 1 8.213 7.435 2.3 2.3 0 0 0-.645.8c-1.3-3.389-4.2-5.749-7.568-5.749-3.442 0-6.3 2.441-7.563 5.735l-.005.014a2.3 2.3 0 0 0-.645-.8 8.265 8.265 0 0 1 8.216-7.436z",
    className: "cls-2",
    transform: "translate(-85.885)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup408);
export default __webpack_public_path__ + "static/media/Group 408.e177a0f723ef5b269a516c4880be710a.svg";
export { ForwardRef as ReactComponent };